/**
 * Poziom amputacji zapisywany na zamówieniu (`order_details.amputation_type`
 * oraz `orders.initial_amputation_type`).
 *
 * Enum mieszkał w `CustomerDetailsForm.vue`; żyje tu, bo zależą od niego także moduły
 * bez interfejsu (kafle ekranu głównego) — a nazwanych eksportów z plików `.vue` nie da
 * się zaimportować w testach jednostkowych. `CustomerDetailsForm.vue` eksportuje go dalej,
 * więc dotychczasowe importy działają bez zmian.
 *
 * Brak wartości „transradial" jest świadomy: mapy wymiarów w karcie PDF i `ElbowSizeService`
 * traktują brak wartości jako transradialny (decyzja GLA-59, punkt 4).
 */
export enum AmputationType {
	TranshumeralAmputation = 'transhumeral_amputation',
	ShoulderDisarticulation = 'shoulder_disarticulation',
}
